import axios from 'axios';
import { API_URL } from '../config/api';
import SessionService from './SessionService';

export interface AIAssistant {
  id: number;
  title: string;
  prompt: string | null;
  knowledgeBase: string | null;
  isActive: boolean;
  businessHoursStart: string | null;
  businessHoursEnd: string | null;
  businessDays: string | null;
  sectorId: number;
  knowledgeBaseChunksCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAIAssistantDTO {
  title: string;
  prompt: string | null;
  knowledgeBase: string | null;
  isActive: boolean;
  businessHoursStart: string | null;
  businessHoursEnd: string | null;
  businessDays: string | null;
  sectorId: number;
}

export interface UpdateAIAssistantDTO {
  title: string;
  prompt: string | null;
  knowledgeBase: string | null;
  isActive: boolean;
  businessHoursStart: string | null;
  businessHoursEnd: string | null;
  businessDays: string | null;
}

const getAuthHeaders = () => {
  const token = SessionService.getToken();
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const getAssistantsBySector = async (sectorId: number): Promise<AIAssistant[]> => {
  const response = await axios.get(`${API_URL}/AIAssistant/sector/${sectorId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getAssistantById = async (id: number): Promise<AIAssistant> => {
  const response = await axios.get(`${API_URL}/AIAssistant/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const createAssistant = async (data: CreateAIAssistantDTO): Promise<AIAssistant> => {
  const response = await axios.post(`${API_URL}/AIAssistant`, data, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateAssistant = async (id: number, data: UpdateAIAssistantDTO): Promise<AIAssistant> => {
  const response = await axios.put(`${API_URL}/AIAssistant/${id}`, data, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const deleteAssistant = async (id: number): Promise<void> => {
  await axios.delete(`${API_URL}/AIAssistant/${id}`, {
    headers: getAuthHeaders(),
  });
};
